import React from 'react';
import './footer.css';

const Footer = () => (
  <footer role="contentinfo">
    <div className="container footer-inner">
      <p>© 2008–{new Date().getFullYear()} Igrecway</p>
      <nav aria-label="Footer">
        <ul>
          <li><a href="/privacypolicy">Privacy Policy</a></li>
          <li><a href="https://www.igrecway.com">Igrecway</a></li>
          <li><a href="mailto:igrecway@gmail.com">Contact</a></li>
        </ul>
      </nav>
    </div>
  </footer>
);

export default Footer;
